import React, { useState, useEffect, Suspense } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';

// Remplace ces imports statiques :
/*
import PortfolioTab from './tablesSQL/PortfolioTab';
import TransactionsTab from './tablesSQL/TransactionsTab';
// etc.
*/

// Par des imports dynamiques :
const PortfolioTab = React.lazy(() => import('./tablesSQL/PortfolioTab'));
const TransactionsTab = React.lazy(() => import('./tablesSQL/TransactionsTab'));
const DividendsTab = React.lazy(() => import('./tablesSQL/DividendsTab'));
const CompaniesTab = React.lazy(() => import('./tablesSQL/CompaniesTab'));
const CashTab = React.lazy(() => import('./tablesSQL/CashTab'));
const MetricsTab = React.lazy(() => import('./MetricsTab'));
const MonthlyUpdate = React.lazy(() => import('./monthlyUpdate/MonthlyUpdate'));
const OnboardingWizard = React.lazy(() => import('./Onboarding/OnboardingWizard'));
const ImportData = React.lazy(() => import('./ImportDataRoute'));
const AccountSettingsRoute = React.lazy(() => import('./AccountSettingsRoute'));

function Dashboard({ showNotification, theme, toggleTheme, isDemo, demoID, monthUpdate, setMonthUpdate }) {

  const lastMonthDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
  const defaultMonthYear = `${String(lastMonthDate.getMonth() + 1).padStart(2, '0')}/${lastMonthDate.getFullYear()}`;

  const [monthYear, setMonthYear] = useState(defaultMonthYear);
  const [monthYearOptions, setMonthYearOptions] = useState([]);
  const [monthYearUpdateRequired, setMonthYearUpdateRequired] = useState(false);

  const navigate = useNavigate();

  const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
    withCredentials: true, // si tu as des cookies/auth
  });

   // Interceptor : ajoute le token à chaque requête
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token'); // ou ton state/context
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  useEffect(() => {
    const params = {isDemo: isDemo, demo_id: demoID}
    
    api.get('/api/month-year-options', { params })
      .then(response => {
        const options = response.data[0].length > 0 
          ? response.data[0]
          : [defaultMonthYear];
        
        setMonthYearOptions(options);
        const initialMonthYear = response.data[1];
//        console.log(initialMonthYear)
        setMonthYear(initialMonthYear || 'Tous');
      })
      .catch(error => {
        showNotification('Erreur lors du chargement des mois/années : ' + error.message, 'error');
        setMonthYearOptions([defaultMonthYear]);
        setMonthYear(defaultMonthYear);
      });
  }, [monthUpdate, monthYearUpdateRequired]);

  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loadingSubscription, setLoadingSubscription] = useState(true);

  useEffect(() => {
    const checkPremium = async () => {

      if (isDemo) {
        setLoadingSubscription(false);
        setIsSubscribed(true)
        return;
      }

      try {
        const res = await api.get('/api/payments/premium-status');
        setIsSubscribed(res.data.isPremium);
      } catch (err) {
        console.error("Erreur statut abonnement", err);
        setIsSubscribed(false);
      } finally {
        setLoadingSubscription(false);
      }
    };

    checkPremium();
  }, [isDemo]);

//  console.log("isSubscribed is ", isSubscribed)

  const commonProps = {
    db: api,
    monthYear,
    setMonthYear,
    monthYearOptions,
    showNotification,
    theme,
    toggleTheme,
    isDemo,
    demoID,
    setMonthUpdate,
    loadingSubscription, 
    isSubscribed,
    setIsSubscribed,
    setMonthYearUpdateRequired
  };
  
  return (
    <Suspense fallback={<div className="p-8 text-center">Chargement...</div>}>
      <Routes>  {/* ← Enveloppe tout dans <Routes> */}
        <Route index element={<Navigate to="portfolio" replace />} />  {/* ← pour /dashboard exactement */}
        <Route path="portfolio" element={<PortfolioTab {...commonProps} />} />
        <Route path="transactions" element={<TransactionsTab {...commonProps} />} />
        <Route path="dividends" element={<DividendsTab {...commonProps} />} />
        <Route path="cash" element={<CashTab {...commonProps} />} />
        <Route path="companies" element={<CompaniesTab {...commonProps} />} />
        <Route path="metrics/*" element={<MetricsTab {...commonProps} />} />
        {/* <Route
          path="metrics/*"
          element={
            loadingSubscription ? (
              <div>Chargement...</div>
            ) : isSubscribed ? (
              <MetricsTab {...commonProps} />
            ) : (
              <div className="p-10 text-center">
                <h2 className="text-2xl font-bold mb-4">Accès réservé aux abonnés Premium</h2>
                <p className="mb-6">Débloquez les métriques avancées dès maintenant !</p>
                <button
                  onClick={() => navigate('/dashboard/settings')}
                  className="px-8 py-4 bg-indigo-600 text-white rounded-xl"
                >
                  Passer Premium
                </button>
              </div>
            )
          }
        /> */}
        <Route path="monthly-update" element={<MonthlyUpdate {...commonProps} />} />
        <Route path="importData" element={<ImportData {...commonProps} />} />
        <Route path="onboarding" element={<OnboardingWizard {...commonProps} />} /> 
        <Route path="settings" element={<AccountSettingsRoute {...commonProps} />} />
        {/* Optionnel : une route par défaut si besoin */}
        <Route path="*" element={<Navigate to="portfolio" replace />} />
      </Routes>
    </Suspense>
  );
}

export default Dashboard;